import { Button, Modal } from '@dev-spendesk/grapes';
import { useState } from 'react';

import { useTranslation } from 'common/hooks/useTranslation';

type Props = {
  isOpen: boolean;
  onCancel(): void;
  onProcessed(): Promise<void>;
  totalAmount: string;
  numberOfRequests: number;
};

export const SubmitDraftsModal = ({
  isOpen,
  onCancel,
  onProcessed,
  totalAmount,
  numberOfRequests,
}: Props) => {
  const { t } = useTranslation('global');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmitDrafts = async () => {
    setIsLoading(true);
    try {
      await onProcessed();
    } catch {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      actions={
        <>
          <Button
            onClick={onCancel}
            text={t('misc.cancel')}
            variant="secondaryNeutral"
            isDisabled={isLoading}
          />
          <Button
            text={t('misc.submit')}
            variant="primaryInfo"
            onClick={handleSubmitDrafts}
            isDisabled={isLoading}
            isLoading={isLoading}
          />
        </>
      }
      iconName="circle-information"
      title={t('requests.draftsList.submitModalTitle', {
        count: numberOfRequests,
      })}
      subtitle={t('requests.draftsList.submitModalContent', {
        count: numberOfRequests,
        amount: totalAmount,
      })}
      iconVariant="info"
      isOpen={isOpen}
    />
  );
};
